import { PersonDetailScreenConfigSchema, type PersonDetailScreenConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Screen `personDetail`.
 *
 * Not absentIsEmpty: the fleet-default SCREEN_CONFIGS row carries
 * `personDetail` (read-only production query, `SystemConfiguration`,
 * 2026-10-02).
 *
 * No fallback: an absent feature under `features` is resolved per feature on
 * mobile, not by one value this entry could mirror.
 */
export const personDetail: ScreenFeatureEntry<'screen', 'personDetail', PersonDetailScreenConfig> = {
  resource: 'screen',
  wireName: 'personDetail',
  schema: PersonDetailScreenConfigSchema,
  // Sparse (U9a): merged inside the server's compare-and-swap, so concurrent sibling saves both land.
  writeMode: 'sparse',
  fallback: {}
}
